/* Optional, manual banner carousel. The default hero needs no JavaScript. */
(() => {
  'use strict';
  if (customElements.get('aapka-home-carousel')) return;
  class AapkaHomeCarousel extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected || this.controller) return;
        this.track = this.querySelector('[data-ae-track]');
        this.slides = [...this.querySelectorAll('[data-ae-slide]')];
        if (!this.track || this.slides.length < 2) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.controls = this.querySelector('[data-ae-controls]');
        this.previous = this.querySelector('[data-ae-prev]');
        this.next = this.querySelector('[data-ae-next]');
        this.status = this.querySelector('[data-ae-status]');
        this.controls.hidden = false;
        this.previous.addEventListener('click', () => this.go(-1), { signal });
        this.next.addEventListener('click', () => this.go(1), { signal });
        this.track.addEventListener('scroll', () => this.schedule(), { passive: true, signal });
        this.addEventListener('shopify:block:select', (event) => {
          const slide = this.slides.find((node) => node.dataset.blockId === event.detail?.blockId);
          if (slide) this.scrollToSlide(slide);
        }, { signal });
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.schedule());
          this.observer.observe(this.track);
        }
        this.update();
      });
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
    }
    update() {
      const start = this.track.getBoundingClientRect().left;
      this.index = this.slides.reduce((best, slide, index) => {
        return Math.abs(slide.getBoundingClientRect().left - start) < Math.abs(this.slides[best].getBoundingClientRect().left - start) ? index : best;
      }, 0);
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.slides.length - 1;
      this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    scrollToSlide(slide) {
      const distance = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollBy({ left: distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    go(direction) {
      this.scrollToSlide(this.slides[Math.max(0, Math.min(this.slides.length - 1, this.index + direction))]);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.controller = null;
    }
  }
  customElements.define('aapka-home-carousel', AapkaHomeCarousel);
})();
